import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { DomainBlock } from './Blocks/DomainBlock';
import { HostingBlock } from './Blocks/HostingBlock';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "EmptyCart-root_2x9VJ",
  "blocksContainer": "EmptyCart-blocksContainer_2zp3z"
};
const products = ['domain', 'paas'];
const productToComponent = {
  domain: /*#__PURE__*/_jsx(DomainBlock, {}, "domain"),
  paas: /*#__PURE__*/_jsx(HostingBlock, {}, "hosting")
};
export default function EmptyCart() {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("p", {
        children: __('Your cart is empty… but not for long!')
      }), /*#__PURE__*/_jsxs("h4", {
        children: [" ", __('Check out our offers.')]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.blocksContainer,
      children: products.map(product => productToComponent[product])
    })]
  });
}